import React from "react";
import { makeStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles({
  colorsNone: {
    background: "#666666",
    marginBottom: "5px",
  },

  colorsConifer: {
    background: "#74a33b",
    marginBottom: "5px",
  },

  colorsDeciduous: {
    backgroundColor: "#cb6527",
    marginBottom: "5px",
  },

  colorsMixed: {
    backgroundColor: "#dba93d",
    marginBottom: "5px",
  },

  colorsDead: {
    backgroundColor: "#373737",
    marginBottom: "5px",
  }
});

export default function LegendForestType() {
  const classes = useStyles();

  return (
    <div>
      <div className="legendForestType">
        <p align="center">Forest Types:</p>
        <Grid container justify="center">

          <Grid item xs={4} className={classes.colorsConifer}>
            <div>
              <span></span>
            </div>
          </Grid>
          <Grid item xs={8}>
            <div>
              <div>
                <span></span>
                <span>Conifer</span>
                <span></span>
              </div>
            </div>
          </Grid>

          <Grid item xs={4} className={classes.colorsDeciduous}>
            <div>
              <span></span>
            </div>
          </Grid>
          <Grid item xs={8}>
            <div>
              <div>
                <span></span>
                <span>Deciduous</span>
                <span></span>
              </div>
            </div>
          </Grid>

          <Grid item xs={4} className={classes.colorsMixed}>
            <div>
              <span></span>
            </div>
          </Grid>
          <Grid item xs={8}>
            <div>
              <div>
                <span></span>
                <span>Mixed</span>
                <span></span>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
